export enum MessageBoxType {
    Default,
    Confirm
}
